<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ asset_maintenance_record.id ? 'Edit ' : 'Create ' }} Maintenance Record</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #f="ngForm" (ngSubmit)="onSubmit(f)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <div class="row">

      <div class="col-12 col-xl-6">

        <div class="row">
          <div class="col-12">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Title</mat-label>
              <input
                matInput
                placeholder="Title"
                [(ngModel)]="asset_maintenance_record.title"
                name="title"
                type="text"
                required
                #title />
              <mat-hint>Please enter a maintenance record title.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Priority</mat-label>
              <mat-select
                [(ngModel)]="asset_maintenance_record.priority"
                required
                name="priority"
                aria-label="Select the priority for this maintenance record.">
                <mat-option
                  *ngFor="let priority of priorityOptions"
                  [value]="priority.value">
                  {{ priority.label }}
                </mat-option>
              </mat-select>
              <mat-hint>Select the priority for this maintenance record.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Status</mat-label>
              <mat-select
                [(ngModel)]="asset_maintenance_record.status"
                required
                name="status"
                aria-label="Select the status for this maintenance record.">
                <mat-option
                  *ngFor="let status of statusOptions"
                  [value]="status.value">
                  {{ status.label }}
                </mat-option>
              </mat-select>
              <mat-hint>Select the status for this maintenance record.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Type</mat-label>
              <mat-select
                [(ngModel)]="asset_maintenance_record.type"
                required
                name="type"
                aria-label="Select the type for this maintenance record.">
                <mat-option
                  *ngFor="let type of typeOptions"
                  [value]="type.value">
                  {{ type.label }}
                </mat-option>
              </mat-select>
              <mat-hint>Select the type for this maintenance record.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6" *ngIf="asset_maintenance_record.type === 'other'">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Other Type</mat-label>
              <input
                matInput
                placeholder="Other Type"
                [(ngModel)]="asset_maintenance_record.type_other"
                name="type_other"
                type="text"
                required
                maxlength="255" />
              <mat-hint>Enter the type when Other is selected.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Description</mat-label>
              <textarea
                matInput
                rows="5"
                placeholder="Description"
                [(ngModel)]="asset_maintenance_record.description"
                name="description"
                id="description">
              </textarea>
              <mat-hint>Enter a description for the maintenance record.</mat-hint>
            </mat-form-field>
          </div>
        </div>

      </div>

      <div class="col-12 col-xl-6">

        <div class="row">
          <div class="col-12 col-md-6">
            <app-datetime-picker
              [selectedDateTime]="dueAtDateTime"
              [isRequired]="true"
              [pickerName]="'dueAtDateTime'"
              [min]="today"
              [label]="'Due At'"
              [hint]="'Use the calendar icon to select the record due date and time.'"
              [selectTooltip]="'Select the record due date and time.'"
              [removeTooltip]="'Clear the record due date and time.'"
              [classes]="'full-width mb-3'"
              (pickerDetailsOutput)="getOutputDueDateTimeDetails($event)"></app-datetime-picker>
          </div>
          <div class="col-12 col-md-6" *ngIf="asset_maintenance_record.status === 'completed'">
            <mat-form-field class="full-width mb-3 cost-amount-field" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Total Cost</mat-label>
              <span matPrefix class="cost-amount-prefix">{{ assetsService.getCostAmountPrefix(app.account.currency_code) }}</span>
              <input
                matInput
                type="number"
                name="total_cost"
                min="0"
                [step]="assetsService.getCurrencyStep(app.account.currency_code)"
                [placeholder]="assetsService.getCurrencyPlaceholder(app.account.currency_code)"
                [(ngModel)]="costAmountInput"
                (ngModelChange)="onCostAmountChange($event)"
                (blur)="onCostAmountBlur()"
              />
              <mat-hint>Please enter a total cost for maintenance.</mat-hint>
              <mat-error *ngIf="costAmountError">
                {{ costAmountError }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="asset_maintenance_record.status === 'completed'">
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Time Spent Unit</mat-label>
              <mat-select
                [(ngModel)]="asset_maintenance_record.time_spent_unit"
                name="time_spent_unit">
                <mat-option
                  *ngFor="let option of timeSpentUnitOptions"
                  [value]="option.value">
                  {{ option.label }}
                </mat-option>
              </mat-select>
              <mat-hint>Select whether the time spent is measured in minutes, hours, or days.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field
              class="full-width mb-3"
              appearance="outline"
              subscriptSizing="dynamic">
              <mat-label>Time Spent</mat-label>
              <input
                matInput
                type="number"
                min="0"
                placeholder="0.00"
                [(ngModel)]="asset_maintenance_record.time_spent_value"
                (blur)="onTimeSpentValueBlur($event)"
                name="time_spent_value"
                #timeSpentValue="ngModel">
              <span matSuffix class="mr-2">
                <ng-container [ngSwitch]="asset_maintenance_record.time_spent_unit">
                  <span *ngSwitchCase="'minutes'">minute(s)</span>
                  <span *ngSwitchCase="'hours'">hour(s)</span>
                  <span *ngSwitchCase="'days'">day(s)</span>
                </ng-container>
              </span>
              <mat-hint>Enter how much time was spent on the maintenance.</mat-hint>
              <mat-error *ngIf="timeSpentValue.hasError('min')">
                Time spent cannot be a negative value.
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="asset_maintenance_record.status === 'completed'">
          <div class="col-12">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Completion Summary</mat-label>
              <textarea
                matInput
                rows="5"
                placeholder="Completion Summary"
                [(ngModel)]="asset_maintenance_record.completion_summary"
                name="completion_summary"
                id="completion_summary">
              </textarea>
              <mat-hint>Enter a summary of the maintenance work completed.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="asset_maintenance_record.status === 'cancelled'">
          <div class="col-12">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Cancellation Details</mat-label>
              <textarea
                matInput
                rows="5"
                placeholder="Cancellation Details"
                [(ngModel)]="asset_maintenance_record.cancellation_details"
                name="cancellation_details"
                id="cancellation_details">
              </textarea>
              <mat-hint>Enter any relevant details about why the maintenance was cancelled.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Notes</mat-label>
              <textarea
                matInput
                rows="5"
                placeholder="Notes"
                [(ngModel)]="asset_maintenance_record.notes"
                name="notes"
                id="notes">
              </textarea>
              <mat-hint>Enter any notes for the maintenance record.</mat-hint>
            </mat-form-field>
          </div>
        </div>

      </div>

    </div>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="p-3">

    <button
      mat-raised-button
      [disabled]="
        !f.valid ||
        !isDueAtValid ||
        (asset_maintenance_record.status === 'completed' && (!isTimeSpentValid || !!costAmountError))
      "
      class="my-2 ml-1 mr-2"
      type="button"
      color="primary"
      id="save_close_button"
      (click)="onSubmit(f)">
      <mat-icon>save</mat-icon>
      Save & Close
    </button>

    <app-file-browse-button
      (selectedFiles)="onSelectFiles($event)"
      (afterDialogClosedEvent)="onSubmit(f, false)"
      parentObjectType="asset-maintenance-record"
      [parentObjectId]="asset_maintenance_record.id"
      [filesCount]="asset_maintenance_record?.files?.length">
    </app-file-browse-button>

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="contractor_selector_button"
      (click)="onSelectContractor()"
      [matBadge]="asset_maintenance_record.contractor_account_id ? '1' : '0'"
      matTooltip="Select the {{ utils.getLangTerm('contractors.singular', 'Contractor').toLowerCase() }} you want the maintenance record to be associated with.">
      <mat-icon>engineering</mat-icon>
      {{ !asset_maintenance_record.contractor_account_id ? 'Select' : 'Change' }} {{ utils.getLangTerm('contractors.singular', 'Contractor') }}
    </button>

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="vendor_selector_button"
      (click)="onSelectVendor()"
      [matBadge]="asset_maintenance_record.vendor_id ? '1' : '0'"
      matTooltip="Select the vendor you want the maintenance record to be associated with.">
      <mat-icon>store</mat-icon>
      {{ !asset_maintenance_record.vendor_id ? 'Select' : 'Change' }} Vendor
    </button>

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="users_selector_button"
      (click)="onSelectUsers()"
      [matBadge]="'' + (asset_maintenance_record.user_ids ? asset_maintenance_record.user_ids?.length : 0)"
      matTooltip="Select the users you want the maintenance record to be associated with.">
      <mat-icon>account_circle</mat-icon>
      Users
    </button>

  </mat-dialog-actions>

</form>

